/**
 * Col definition name for event columns for controls table
 */
export const EVENT_CELL_COLUMN_DEF = '__eventCell';

/**
 * Col definition for selection mode for controls table
 */
export const SELECT_CELL_COLUMN_DEF = '__select';
